import cn from 'classnames';

import type { Locale } from '@shared/libs';
import styles from './labels.module.css';

type TProps = {
  locale: Locale;
};

export const Ready = ({ locale }: TProps) => (
  <div className={cn(styles.label, styles.ready)}>
    {locale.AI_PLAYER_READY_VIDEO || 'AI_PLAYER_READY_VIDEO'}
  </div>
);
